import script from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordReset.vue?vue&type=style&index=0&id=69f32dc4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69f32dc4"]])

export default __exports__